//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiCell from "../../components/cell/Index.vue";
import HiHeader from "../../components/header/Index.vue";
import HiButton from "../../components/button/Index.vue";
import { login } from "../../apis/users";

export default {
  name: "PaymentBillingPage",
  components: { HiCell, HiHeader, HiButton },
  methods: {
    /**
     * 强制返回My plan页面
     */
    overrideBackClick() {
      this.$router.push({ name: "MyPlanPage" });
    },
    /**
     * 编辑按钮点击事件
     */
    async edit() {
      this.$router.push({ name: "PaymentBillingEditPage" });
    },
  },
  data() {
    return {
      hideBackBtn: false,
      creditCard: null,
    };
  },
  async activated() {
    this.hideBackBtn = this.$route.query.back === "no";

    // 获取用户的 creditCard 用于显示但是不影响 store 中的数据以免出现问题
    (async () => {
      try {
        this.$loading.show();

        const { data: user } = await login({
          ignoreToken: false,
          with_stripe: true,
        });

        this.creditCard = user.credit_card;
      } catch (error) {
      } finally {
        this.$loading.hide();
      }
    })();
  },
};



// WEBPACK FOOTER //
// ./src/pages/payment/Billing.vue